import { Skeleton } from '@bbl-digital/snorre'

const MostFrequentRecipientsLoading: React.FC = () => {
  const list = Array.from(Array(10).keys())
  const BASE_WIDTH = 110
  return (
    <>
      {list.map((i) => (
        <Skeleton key={i} height="20px" width={`${BASE_WIDTH + i * 10}px`} />
      ))}
    </>
  )
}

export default MostFrequentRecipientsLoading
